import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";

const input = "w-full h-11 px-3 bg-[#1F2230] border border-[#3B4157] text-sm outline-none focus:border-orange-500";
const TYPES = ["mt_tractor", "mt_combine", "mt_excavator", "mt_loader", "mt_other"];

export const MissingSeatForm = ({ query }) => {
  const { t } = useLang();
  const [f, setF] = useState({ machine_type: t("mt_tractor"), model: "", year: "", phone: "", email: "", consent: false });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.model.trim().length < 2) return toast.error(t("msf_model_req"));
    if (f.phone.trim().length < 5 && !f.email.trim()) return toast.error(t("msf_contact_req"));
    if (!f.consent) return toast.error(t("consent_required"));
    setBusy(true);
    try { await api.post("/seat-requests", { ...f, query }); setDone(true); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  if (done) return (
    <div data-testid="missing-seat-done" className="border border-emerald-500/40 bg-[#292D3C] p-8 text-center">
      <CheckCircle2 className="w-8 h-8 text-emerald-400 mx-auto" />
      <p className="mt-3 font-display font-bold uppercase tracking-wider">{t("msf_done")}</p>
    </div>
  );

  return (
    <form data-testid="missing-seat-form" onSubmit={submit} className="border border-[#3B4157] bg-[#292D3C] p-6 sm:p-8 space-y-4">
      <div>
        <h3 className="font-display font-black uppercase text-xl tracking-tight">{t("msf_title")}</h3>
        <p className="text-sm text-slate-400 mt-1">{t("msf_sub")}</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <select data-testid="msf-type" value={f.machine_type} onChange={set("machine_type")} className={input}>
          {TYPES.map((k) => <option key={k} value={t(k)}>{t(k)}</option>)}
        </select>
        <input data-testid="msf-model" value={f.model} onChange={set("model")} placeholder={t("msf_model")} className={input} />
        <input data-testid="msf-year" value={f.year} onChange={set("year")} placeholder={t("msf_year")} inputMode="numeric" className={input} />
        <input data-testid="msf-phone" value={f.phone} onChange={set("phone")} placeholder={t("msf_phone")} type="tel" className={input} />
        <input data-testid="msf-email" value={f.email} onChange={set("email")} placeholder={t("msf_email")} type="email" className={`${input} sm:col-span-2`} />
      </div>
      <label className="flex items-start gap-3 text-sm text-slate-300 cursor-pointer">
        <input data-testid="msf-consent" type="checkbox" checked={f.consent} onChange={set("consent")} className="accent-orange-500 w-4 h-4 mt-0.5" />
        <span>{t("consent_1")} <Link to="/privacy" target="_blank" className="text-orange-500 underline underline-offset-2">{t("consent_privacy")}</Link> *</span>
      </label>
      <button data-testid="msf-submit" disabled={busy} className="h-12 px-8 bg-orange-500 text-[#1F2230] font-display font-bold uppercase tracking-widest hover:bg-orange-400 disabled:opacity-60 inline-flex items-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} {t("msf_submit")}
      </button>
    </form>
  );
};
